var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentItem)?_c('div',{staticClass:"p-2"},[_c('h3',{staticClass:"ml-1",staticStyle:{"color":"#2662bb"}},[_vm._v("详情")]),_c('form-view',{attrs:{"item":_vm.currentItem,"fields":_vm.detailFields}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }